var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Cards/Transportation/Hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Cards/Transportation/Hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Cards/Transportation"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#A12885",
    fillRule: "nonzero",
    cx: 40,
    cy: 40,
    r: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "directions_car",
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 40 0 40 40 0 40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5333333,10.0166667 C31.2,9.03333333 30.2666667,8.33333333 29.1666667,8.33333333 L10.8333333,8.33333333 C9.73333333,8.33333333 8.81666667,9.03333333 8.46666667,10.0166667 L5.18333333,19.4666667 C5.06666667,19.8166667 5,20.1833333 5,20.5666667 L5,32.5 C5,33.8833333 6.11666667,35 7.5,35 C8.88333333,35 10,33.8833333 10,32.5 L10,31.6666667 L30,31.6666667 L30,32.5 C30,33.8666667 31.1166667,35 32.5,35 C33.8666667,35 35,33.8833333 35,32.5 L35,20.5666667 C35,20.2 34.9333333,19.8166667 34.8166667,19.4666667 L31.5333333,10.0166667 Z M10.8333333,26.6666667 C9.45,26.6666667 8.33333333,25.55 8.33333333,24.1666667 C8.33333333,22.7833333 9.45,21.6666667 10.8333333,21.6666667 C12.2166667,21.6666667 13.3333333,22.7833333 13.3333333,24.1666667 C13.3333333,25.55 12.2166667,26.6666667 10.8333333,26.6666667 Z M29.1666667,26.6666667 C27.7833333,26.6666667 26.6666667,25.55 26.6666667,24.1666667 C26.6666667,22.7833333 27.7833333,21.6666667 29.1666667,21.6666667 C30.55,21.6666667 31.6666667,22.7833333 31.6666667,24.1666667 C31.6666667,25.55 30.55,26.6666667 29.1666667,26.6666667 Z M8.33333333,18.3333333 L10.45,11.9666667 C10.6833333,11.3 11.3166667,10.8333333 12.0333333,10.8333333 L27.9666667,10.8333333 C28.6833333,10.8333333 29.3166667,11.3 29.55,11.9666667 L31.6666667,18.3333333 L8.33333333,18.3333333 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.ed4480303f45ad34abc886c1355c2ec4.svg";
export { ForwardRef as ReactComponent };